import { Component, OnInit ,Input } from '@angular/core';
import { WorkshopConfigurationModel } from 'src/app/models/workshop-configuration.model';
import { LokijsService } from 'src/app/services/database/lokijs.service';
import {LoadingController, ModalController} from '@ionic/angular';

@Component({
  selector: 'app-service-job-filters',
  templateUrl: './service-job-filters.page.html',
  styleUrls: ['./service-job-filters.page.scss'],
})
export class ServiceJobFiltersPage implements OnInit {

  @Input() workshopConfiguration: WorkshopConfigurationModel;

  loading: any;

  jobOrdering: string;
  showJobStatusCard: boolean;

  constructor(public modalController: ModalController,
              private loadingController: LoadingController,
              private loki: LokijsService) {
  }

  ngOnInit() {
      this.init();
  }

  async init() {
    
   

  
  }


  async applyFilter() {
      this.modalController.dismiss();
  }

  handleValueChange($event){

      console.log($event.target.value);
      this.workshopConfiguration.jobOrdering = $event.target.value;
     
  }


}
